import type { TOC } from '@ember/component/template-only'

interface Signature {
  Element: Element
  Blocks: {
    left: []
    title: []
    right: []
    lowerLeft: []
    lowerCenter: []
    lowerRight: []
  }
}

export const PageHeader: TOC<Signature> = <template>
  <page-header
    class="m-3 grid grid-cols-[1fr_auto_1fr] items-baseline gap-3 print:grid-cols-1"
    data-test-page-header
    ...attributes
  >
    {{! Title row }}
    <div class="text-left print:hidden" data-test-page-header-left>
      {{yield to="left"}}
    </div>
    <div class="text-center print:font-bold" data-test-page-header-title>
      {{yield to="title"}}
    </div>
    <div class="text-right print:hidden" data-test-page-header-right>
      {{yield to="right"}}
    </div>
    {{! Lower }}
    <div class="text-left print:hidden" data-test-page-header-lower-left>
      {{yield to="lowerLeft"}}
    </div>
    <div class="text-center print:hidden" data-test-page-header-lower-center>
      {{yield to="lowerCenter"}}
    </div>
    <div class="text-right print:hidden" data-test-page-header-lower-right>
      {{yield to="lowerRight"}}
    </div>
    {{! Divider }}
    <hr class="border-dusty-black-50 col-span-3 mx-[12.5%] my-0 border-t-2 print:hidden" />
  </page-header>
</template>

export default PageHeader
